import type { BlockContent } from '../../api/bindings/BlockContent.ts';
import { CanvasEdit, CanvasView } from './Canvas.tsx';
import { ChecklistEdit, ChecklistView } from './Checklist.tsx';
import { DataTableEdit, DataTableView } from './DataTable.tsx';
import { KvListEdit, KvListView } from './KvList.tsx';
import { MetricGridEdit, MetricGridView } from './MetricGrid.tsx';
import { NarrativeEdit, NarrativeView } from './Narrative.tsx';
import { PhaseListEdit, PhaseListView } from './PhaseList.tsx';
import { RiskListEdit, RiskListView } from './RiskList.tsx';
import { SwotEdit, SwotView } from './Swot.tsx';
import { TeamListEdit, TeamListView } from './TeamList.tsx';

export function BlockView({ content }: { content: BlockContent }) {
  switch (content.kind) {
    case 'narrative':
      return <NarrativeView content={content} />;
    case 'metric_grid':
      return <MetricGridView content={content} />;
    case 'canvas':
      return <CanvasView content={content} />;
    case 'swot':
      return <SwotView content={content} />;
    case 'table':
      return <DataTableView content={content} />;
    case 'risk_list':
      return <RiskListView content={content} />;
    case 'phase_list':
      return <PhaseListView content={content} />;
    case 'checklist':
      return <ChecklistView content={content} />;
    case 'team_list':
      return <TeamListView content={content} />;
    case 'kv_list':
      return <KvListView content={content} />;
  }
}

export function BlockEdit({
  content,
  onChange,
}: {
  content: BlockContent;
  onChange: (content: BlockContent) => void;
}) {
  switch (content.kind) {
    case 'narrative':
      return <NarrativeEdit content={content} onChange={onChange} />;
    case 'metric_grid':
      return <MetricGridEdit content={content} onChange={onChange} />;
    case 'canvas':
      return <CanvasEdit content={content} onChange={onChange} />;
    case 'swot':
      return <SwotEdit content={content} onChange={onChange} />;
    case 'table':
      return <DataTableEdit content={content} onChange={onChange} />;
    case 'risk_list':
      return <RiskListEdit content={content} onChange={onChange} />;
    case 'phase_list':
      return <PhaseListEdit content={content} onChange={onChange} />;
    case 'checklist':
      return <ChecklistEdit content={content} onChange={onChange} />;
    case 'team_list':
      return <TeamListEdit content={content} onChange={onChange} />;
    case 'kv_list':
      return <KvListEdit content={content} onChange={onChange} />;
  }
}
